import {
  CONTENT_ID_CLAIMS_LOADED,
  CONTENT_ID_CLAIMS_CLEAR,
  CONTENT_ID_CLAIMS_STATUS_PATCH,
  CONTENT_ID_CLAIM_DETAILS_LOADED,
  CONTENT_ID_CLAIM_DETAILS_CLEAR,
  CONTENT_ID_CLAIM_HISTORY_LOADED,
  CONTENT_ID_CLAIM_HISTORY_CLEAR,
  CONTENT_ID_MANUAL_CLAIM_REQUESTS_LOADED,
  CONTENT_ID_MANUAL_CLAIM_REQUESTS_CLEAR,
  CONTENT_ID_MANUAL_CLAIM_REQUEST_DETAIL_LOADED,
  CONTENT_ID_MANUAL_CLAIM_REQUEST_DETAIL_CLEAR,
  CONTENT_ID_CLAIM_RELEASE_REQUESTS_LOADED,
  CONTENT_ID_CLAIM_RELEASE_REQUESTS_CLEAR,
  CONTENT_ID_CLAIM_RELEASE_REQUEST_DETAIL_LOADED,
  CONTENT_ID_CLAIM_RELEASE_REQUEST_DETAIL_CLEAR,
} from '../../../actions/actionTypes';

const initialState = {
  claims: null,
  claimDetails: null,
  claimHistory: null,
  manualClaimRequests: null,
  manualClaimRequestDetail: null,
  claimReleaseRequests: null,
  claimReleaseRequestDetail: null,
};

const contentIdClaims = (state = initialState, action) => {
  switch (action.type) {
    case CONTENT_ID_CLAIMS_LOADED:
      return {
        ...state,
        claims: action.payload.claims,
      };

    case CONTENT_ID_CLAIMS_CLEAR:
      return {
        ...state,
        claims: null,
      };

    case CONTENT_ID_CLAIMS_STATUS_PATCH: {
      // { claimIds: string[], status: string }
      const { claimIds, status } = action.payload;
      const idSet = new Set(claimIds);
      return {
        ...state,
        claims: state.claims
          ? {
            ...state.claims,
            // eslint-disable-next-line no-confusing-arrow
            data: (state.claims.data || []).map((c) => (idSet.has(c.id) ? { ...c, status } : c)),
          }
          : state.claims,
      };
    }

    case CONTENT_ID_CLAIM_DETAILS_LOADED:
      return {
        ...state,
        claimDetails: action.payload.claimDetails,
      };

    case CONTENT_ID_CLAIM_DETAILS_CLEAR:
      return {
        ...state,
        claimDetails: null,
      };

    case CONTENT_ID_CLAIM_HISTORY_LOADED:
      return {
        ...state,
        claimHistory: action.payload.claimHistory,
      };

    case CONTENT_ID_CLAIM_HISTORY_CLEAR:
      return {
        ...state,
        claimHistory: null,
      };

    case CONTENT_ID_MANUAL_CLAIM_REQUESTS_LOADED:
      return {
        ...state,
        manualClaimRequests: action.payload.manualClaimRequests,
      };

    case CONTENT_ID_MANUAL_CLAIM_REQUESTS_CLEAR:
      return {
        ...state,
        manualClaimRequests: null,
      };

    case CONTENT_ID_MANUAL_CLAIM_REQUEST_DETAIL_LOADED:
      return {
        ...state,
        manualClaimRequestDetail: action.payload.manualClaimRequestDetail,
      };

    case CONTENT_ID_MANUAL_CLAIM_REQUEST_DETAIL_CLEAR:
      return {
        ...state,
        manualClaimRequestDetail: null,
      };

    case CONTENT_ID_CLAIM_RELEASE_REQUESTS_LOADED:
      return {
        ...state,
        claimReleaseRequests: action.payload.claimReleaseRequests,
      };

    case CONTENT_ID_CLAIM_RELEASE_REQUESTS_CLEAR:
      return {
        ...state,
        claimReleaseRequests: null,
      };

    case CONTENT_ID_CLAIM_RELEASE_REQUEST_DETAIL_LOADED:
      return {
        ...state,
        claimReleaseRequestDetail: action.payload.claimReleaseRequestDetail,
      };

    case CONTENT_ID_CLAIM_RELEASE_REQUEST_DETAIL_CLEAR:
      return {
        ...state,
        claimReleaseRequestDetail: null,
      };

    default:
      return state;
  }
};

export default contentIdClaims;
